export default __webpack_public_path__ + "static/media/PR.STREAK.THREE_MONTHS.93af8e54.jpg";